import React from 'react';
import PropTypes from 'prop-types';
import FlexContainer from '../FlexContainer/FlexContainer';
import Gift01Icon from '../Icons/Gift01Icon';
import Text from '../Text/Text';
import Tooltip from '../Tooltip/Tooltip';
import BundleIncludesCaption from './BundleIncludesCaption';
import BundlePartOfUpgradeCaption from './BundlePartOfUpgradeCaption';
import {colors} from '../../utils/colors.js';
import css from './BundleMarker.module.scss';

const ICON_STYLE = {flexShrink: 0, width: 15, height: 15, cursor: 'default'};
const TOOLTIP_ICON_STYLE = {display: 'flex', alignItems: 'center'};
const TOOLTIP_TEXT_STYLE = {minWidth: 0, display: 'block'};
const TOOLTIP_MAX_WIDTH = 240;

const CaptionText = ({children}) => (
  <Text size="xs" color="muted">{children}</Text>
);

CaptionText.propTypes = {
  children: PropTypes.node.isRequired,
};

const resolveCaption = (roomTypeId, bookedExtras) => {
  if (roomTypeId) {
    return <BundlePartOfUpgradeCaption roomTypeId={roomTypeId}/>;
  }

  if (bookedExtras?.length > 0) {
    return <BundleIncludesCaption bookedExtras={bookedExtras}/>;
  }

  return null;
};

const BundleMarker = ({roomTypeId = null, bookedExtras = [], captionPlacement = 'below', children}) => {
  const icon = <Gift01Icon color={colors.preArrival} style={ICON_STYLE}/>;
  const caption = resolveCaption(roomTypeId, bookedExtras);

  if (captionPlacement === 'tooltip') {
    return (
      <FlexContainer gap={6} alignItems="center" justifyContent="center" width="100%">
        <Tooltip content={caption} show={Boolean(caption)} position="top" portal maxWidth={TOOLTIP_MAX_WIDTH} style={TOOLTIP_ICON_STYLE}>
          {icon}
        </Tooltip>
        <Text truncate>{children}</Text>
      </FlexContainer>
    );
  }

  return (
    <FlexContainer className={css.bundleMarkerCell} flexDirection="column" flexFlow="column" gap={2} alignItems="center" justifyContent="center" width="100%">
      <FlexContainer className={css.bundleMarkerRow} gap={6} alignItems="center" justifyContent="center" width="100%">
        {icon}
        <Tooltip content={children} position="top" portal maxWidth={TOOLTIP_MAX_WIDTH} style={TOOLTIP_TEXT_STYLE}>
          <Text truncate>{children}</Text>
        </Tooltip>
      </FlexContainer>
      {caption && <CaptionText>{caption}</CaptionText>}
    </FlexContainer>
  );
};

BundleMarker.propTypes = {
  roomTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bookedExtras: PropTypes.arrayOf(PropTypes.shape({
    extraTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    quantity: PropTypes.number,
  })),
  captionPlacement: PropTypes.oneOf(['below', 'tooltip']),
  children: PropTypes.node.isRequired,
};

export default BundleMarker;
